import React from 'react'
import { FaTwitterSquare, FaGithubSquare} from "react-icons/fa";


const SocialLinks = [
    {
        id: 1,
        name: "Twitter",
        url: "https://twitter.com/itscoldbolt",
        icon: < FaTwitterSquare/>
    },
    {
        id: 2,
        name: "Github",
        url: "https://github.com/Coldboltage/",
        icon: <FaGithubSquare/>
    }
]

export default SocialLinks